<template>
  <b-collapse class="card evaluation-card" animation="slide" :open="open">
    <template #trigger="{ open }">
      <div class="card-header mb-1" role="button" :aria-expanded="open.toString()">
        <p class="card-header-title">
          {{ title }}
        </p>
        <a class="card-header-icon">
          <b-icon v-if="!showIconLabel && !iconConfig" :icon="open ? 'minus' : 'plus'" />
          <span v-if="showIconLabel">{{ iconLabel }}</span>
          <b-icon v-if="iconConfig" class="evaluation-icon" :icon="iconConfig.icon" :type="iconConfig.type" />
        </a>
      </div>
    </template>
    <EvaluationSummaryItem :data="data" />
  </b-collapse>
</template>

<script>
import EvaluationSummaryItem from '@/ui/components/internal/evaluations/EvaluationSummaryItem.vue';

export default {
  name: 'TableSummary',
  components: { EvaluationSummaryItem },
  props: {
    title: {
      type: String,
      required: true
    },
    iconLabel: {
      required: false
    },
    showIconLabel: {
      type: Boolean,
      default: false
    },
    iconConfig: {
      type: Object,
      required: false
    },
    data: {
      type: Object,
      required: true
    },
    open: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.card {
  box-shadow: none;
  margin-bottom: 1rem;
}
</style>
<style>
.evaluation-card .card-header {
  padding: 0.4rem 16px;
  border-radius: 10px;
  background: #F2F2F2;
  box-shadow: none;
}
.evaluation-card .card-header-title,
.evaluation-card .card-header-icon {
  padding: 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: #4D4D4D;
}
</style>
